import {Routes} from '@src/Constant/routes';
import useNavigation from '@src/Navigation/useNavigation';

const shouldNavigate = () =>
  typeof window !== 'undefined' &&
  !window.location.pathname.includes('/tv-auth') &&
  !window.location.pathname.includes('/subscription');

const useSignInSuccess = (redirectUrl: Routes | string = Routes.APP) => {
  const {navigate} = useNavigation();
  const onSuccess = async () =>
    shouldNavigate() &&
    (await navigate(redirectUrl, {
      replace: true,
    }));

  return {onSuccess};
};

export default useSignInSuccess;
